var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{key:_vm.node._key,tag:"component",attrs:{"params":_vm.compParams,"route-node":_vm.node,"route-params":_vm.compRouteParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }